import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Globe, Users } from 'lucide-react';
import { useUserSettings } from '../../hooks/useUserSettings';
import { useAnonymization } from '../../utils/anonymize';
import { Skeleton } from '../ui/Skeleton';
import type { Company } from '../../types/company';

interface CompanyListProps {
  companies: Company[];
}

export default function CompanyList({ companies }: CompanyListProps) {
  const { settings, loading: settingsLoading } = useUserSettings();
  const shouldAnonymize = settings?.anonymizing_mode || false;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {companies.map((company) => (
        <Link
          key={company.id}
          to={`/companies/${company.id}`}
          className="card p-4 hover:border-primary-500 transition-colors"
        >
          <div className="flex items-start justify-between">
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Building2 className="w-5 h-5 text-primary-500" />
                {settingsLoading ? (
                  <Skeleton className="h-6 w-32" />
                ) : (
                  <h3 className="text-lg font-semibold">
                    {useAnonymization(company.name, 'company', shouldAnonymize)}
                  </h3>
                )}
              </div>
              {company.industry && (
                <p className="text-sm text-gray-400">
                  {useAnonymization(company.industry, 'company', shouldAnonymize)}
                </p>
              )}
              {company.website && (
                <div className="flex items-center text-sm text-gray-400">
                  <Globe className="w-4 h-4 mr-2" />
                  {settingsLoading ? (
                    <Skeleton className="h-4 w-32" />
                  ) : (
                    <span>
                      {shouldAnonymize ? '*********.***' : new URL(company.website).hostname}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}